import { AxiosRequestConfig } from 'axios';
import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { PromotionReplyOrder } from '@diritto/common/promotion/constants';
import { Http } from '@diritto/common/utils/requester/http';
import { CreatePromotionReplyDto } from '@diritto/common/promotion/dtos/create-promotion-reply.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import {
  PromotionReplyLikeResponseDto,
  PromotionReplyResponseDto,
} from '@diritto/common/promotion/dtos/promotion-reply.dto';

export interface GetPromotionRepliesQuery {
  promotionId: number;
  promotionItemId: number;
  orderBy: PromotionReplyOrder;
}

export class PromotionReplyApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getPromotionReplies(params: BasePaginatorDto & GetPromotionRepliesQuery, options?: AxiosRequestConfig) {
    const res = await this.http.get<PromotionReplyResponseDto>(`${this.url}/promotions/${params.promotionId}/reply`, {
      params: {
        promotionItemId: params.promotionItemId,
        orderBy: params.orderBy,
        limit: params.limit,
        offset: params.offset,
      },
      ...options,
    });
    return res.data;
  }

  async getPromotionReplyLikes(promotionId: number, promotionReplyIds: string[], options?: AxiosRequestConfig) {
    const res = await this.http.get<PromotionReplyLikeResponseDto>(
      `${this.url}/promotions/${promotionId}/reply/likes`,
      {
        params: { replyIds: promotionReplyIds.join(',') },
        ...options,
      },
    );
    return res.data;
  }

  async likePromotionReply(promotionId: number, replyId: string, options?: AxiosRequestConfig) {
    const res = await this.http.post<object, ResponseDto>(
      `${this.url}/promotions/${promotionId}/reply/${replyId}/like`,
      {},
      options,
    );
    return res.data;
  }

  async unlikePromotionReply(promotionId: number, replyId: string, options?: AxiosRequestConfig) {
    const res = await this.http.delete<ResponseDto>(
      `${this.url}/promotions/${promotionId}/reply/${replyId}/like`,
      options,
    );
    return res.data;
  }

  async deletePromotionReply(promotionId: number, replyId: string, options?: AxiosRequestConfig) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/promotions/${promotionId}/reply/${replyId}`, options);
    return res.data;
  }

  async createPromotionReply(promotionId: number, replyDto: CreatePromotionReplyDto, options?: AxiosRequestConfig) {
    const res = await this.http.post<CreatePromotionReplyDto, ResponseDto>(
      `${this.url}/promotions/${promotionId}/reply`,
      replyDto,
      options,
    );
    return res.data;
  }
}
